// there're some edge cases
// when element should be included to same bounds list to source element
// event though their bounds differ

import isElementColumn from '../../blocks/helpers/is-element-column';
import isElementWidget from '../../blocks/helpers/is-element-widget';

const QUOTE_WIDGET_SELECTOR = 'ws-block[widget="quote"]';
const LIST_WITH_ICONS_WIDGET_SELECTOR = 'ws-block[widget="list-with-icons"]';
const FOLLOW_US_WIDGET_SELECTOR = 'ws-block[widget="follow-us"]';
const IMAGE_WIDGET_SELECTOR = 'ws-block[widget="image"]';
const VIDEO_WIDGET_SELECTOR = 'ws-block[widget="video"]';
const MUSIC_WIDGET_SELECTOR = 'ws-block[widget="music"]';
const EMBED_WIDGET_SELECTOR = 'ws-block[widget="embed"]';

const widgetsToSkip = [
  QUOTE_WIDGET_SELECTOR,
  FOLLOW_US_WIDGET_SELECTOR,
  LIST_WITH_ICONS_WIDGET_SELECTOR,
  IMAGE_WIDGET_SELECTOR,
  VIDEO_WIDGET_SELECTOR,
  MUSIC_WIDGET_SELECTOR,
  EMBED_WIDGET_SELECTOR,
];

// 1. when it is gallery widget
// to show gallery control pane trigger on gallery item select
const shouldIncludeGalleryWidget = (targetElement) =>
  targetElement.matches('ws-block[widget="gallery"]');

// 2. when it is media container with iframe inside
// to prevent auto activation of one control pane trigger during resize
const shouldIncludeMediaContainerForIframe = (sourceElement, targetElement) => {
  const isIframe = sourceElement.matches('ws-iframe');

  if (!isIframe) return false;

  const isMediaContainer = targetElement.matches('ws-media-container');

  return isMediaContainer;
};

// 3. When a narrower element is placed inside widget but we need
// to show merged controls for both this element and the widget
const shouldIncludeParentWidgetForElement = (sourceElement, targetElement) => {
  const isSourceElementColumn = isElementColumn(sourceElement);
  const isSourceElementWidget = isElementWidget(sourceElement);
  const isTargetElementFirstParentWidget =
    isElementWidget(targetElement) && sourceElement.closest('[widget]') === targetElement;

  // There are widgets with specific layout so we don't need to process it here
  const isTargetElementWidgetToSkip = targetElement.matches(widgetsToSkip.join(', '));

  return (
    !isSourceElementColumn &&
    !isSourceElementWidget &&
    isTargetElementFirstParentWidget &&
    !isTargetElementWidgetToSkip
  );
};

const shouldBeTakenAsSameBounds = (sourceElement, targetElement) =>
  shouldIncludeGalleryWidget(targetElement) ||
  shouldIncludeMediaContainerForIframe(sourceElement, targetElement) ||
  shouldIncludeParentWidgetForElement(sourceElement, targetElement);

export default shouldBeTakenAsSameBounds;
